import React from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Grid, Typography } from "@mui/material";

export default function TodaysDetialsAndSession({attendanceDetails}) {
  const today = new Date();
  const firstName =localStorage.getItem("firstName")
  const lastName =localStorage.getItem("lastName")
  // Format the date
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = today.toLocaleDateString("en-US", options);
  return (
    <GlobalCard padding="10px">
      <Grid container spacing={2} px={1}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          justifyContent={{ xs: "center", md: "left" }}
          container
          gap={1}
          alignItems="center"
        >
          <Box width={20}>
            <img src="/newdashboard/Classrom/Attendance/uis_calender (1).png" />
          </Box>
          <Typography
            color="#111111"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            {" "}
            {formattedDate}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          container
          direction="row"
          justifyContent={{ xs: "center", md: "flex-end" }}
          alignItems="center"
          gap={2}
        >
          {/* Text Block */}
          <Box>
            <Typography
              color="#111111"
              fontFamily="Inter"
              fontSize="14px"
              lineHeight="100%"
              fontStyle="normal"
              fontWeight={700}
              textAlign="end"
            >
           {firstName} {lastName}
            </Typography>

            <Typography
              mt={1}
              color="#555555"
              fontFamily="Inter"
              fontSize="16px"
              lineHeight="100%"
              fontStyle="normal"
              fontWeight={400}
            >
              Total sessions : {attendanceDetails?.total_sessions}
            </Typography>
          </Box>

          {/* Image Block */}
          <Box display="flex" alignItems="center">
            <Box width={40} height={40}>
              <img
                src="/newdashboard/Demo/Group 1171283716.png"
                alt="avatar"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </GlobalCard>
  );
}
